import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Directory indexing all internal site paths for keyword matching
const searchablePages = [
  { path: '/cardiology', title: 'Cardiology & Heart Bypass Surgery', tags: 'heart cardio bypass cabg stenting angioplasty chest pain blockages multi-specialty private valve replacement' },
  { path: '/orthopedics', title: 'Orthopedics & Robotic Joint Replacement', tags: 'knee hip reconstruction arthroplasty spine joint bone density physiotherapy implants' },
  { path: '/oncology', title: 'Oncology & Advanced Cancer Care', tags: 'cancer tumor chemotherapy radiation cyberknife proton beam bone marrow transplant biopsy molecular' },
  { path: '/dental', title: 'Affordable Dental Tourism Packages', tags: 'dental teeth implants crown veneer root canal cosmetic maxilla private dentistry' },
  { path: '/destinations', title: 'Top Medical Cities Guide', tags: 'delhi ncr mumbai chennai destinations cities airport gurgaon noida metropolitan transit accommodations' },
  { path: '/medical-updates', title: 'Latest Medical Updates & Technological Breakthroughs', tags: 'updates clinical innovations da vinci technology advancements hardware systems publications news' },
  { path: '/success-stories', title: 'Patient Success Stories & Testimonials', tags: 'success stories outcomes recovery profiles case study reviews ratings tracks patient experience' },
  { path: '/patient-support', title: 'International Patient Support Services', tags: 'support language translator concierge helper airport pickup luggage lounge frro companion attendance suite' },
  { path: '/visa-guides', title: 'Step-by-Step International Medical Visa Guidelines', tags: 'visa guidelines e-medical visa documentation vil invitation letter stamping embassy clearance pass passport entry' },
  { path: '/visa-assistance', title: 'Medical Visa Application Assistance Desk', tags: 'visa assistance paper invitation letter passport control clearances legal files processing form registration' },
  { path: '/visa-processing', title: 'Online Visa Processing Mechanics and Timelines', tags: 'visa processing queue system digital portal web timeline approvals hours duration entry requirements' },
  { path: '/visa-extension', title: 'Medical Visa Extension & Stay Prolongation', tags: 'visa extension stay prolongation frro renewal add days months form c registration penalty overstay' },
  { path: '/travel-advisories', title: 'International Travel Advisories & Flight Logistics', tags: 'travel advisories flights logistics arrivals airport igi terminal layovers weather timing transport security' },
  { path: '/treatments', title: 'Advanced Medical Specialties Matrix', tags: 'treatments surgical pathways health indexes clinical conditions cost saving benchmarks overview' },
  { path: '/hospitals', title: 'Find Premium Private Corporate Hospitals', tags: 'find hospitals corporate jci accredited nabh multi-specialty healthcare networks private wings facilities sanitization' }
];

function SearchResults() {
  const location = useLocation();
  
  // Extract query string parameter (?q=...)
  const queryParams = new URLSearchParams(location.search);
  const rawQuery = queryParams.get('q') || '';
  const cleanQuery = rawQuery.toLowerCase().trim();

  // Filter list by tracking occurrences of search term in fields or tags
  const filteredResults = searchablePages.filter(page => 
    page.title.toLowerCase().includes(cleanQuery) || 
    page.tags.toLowerCase().includes(cleanQuery)
  );

  return (
    <div className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif', 
      minHeight: '500px',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT HOVER REFINEMENTS */}
      <style>{`
        .search-result-card { transition: all 0.2s ease; border: 1px solid #e2e8f0; }
        .search-result-card:hover { border-color: #cbd5e1; box-shadow: 0 4px 12px rgba(0,0,0,0.03); }
        @media (max-width: 480px) {
          .search-dir-btn { width: 100% !important; text-align: center; display: block !important; box-sizing: border-box; }
        }
      `}</style>

      <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '12px', fontSize: 'clamp(1.3rem, 5vw, 1.75rem)', margin: '0 0 15px 0' }}>
        Search Results Lookup Portal
      </h2>

      <p style={{ margin: '15px 0 25px 0', color: '#555', fontSize: 'clamp(0.95rem, 3.5vw, 1.05rem)', lineHeight: '1.5' }}>
        Showing filtered system items for query: <strong style={{ color: '#005ba1' }}>"{rawQuery}"</strong> ({filteredResults.length} records discovered)
      </p>

      {/* LIST GENERATOR */}
      {filteredResults.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {filteredResults.map((item, index) => (
            <div key={index} className="search-result-card" style={{ padding: '16px', borderRadius: '6px', background: '#fdfdfd', boxSizing: 'border-box' }}>
              <h3 style={{ margin: '0 0 8px 0', fontSize: 'clamp(1.05rem, 4vw, 1.2rem)', lineHeight: '1.4' }}>
                <Link to={item.path} style={{ color: '#0b3c5d', textDecoration: 'none', fontWeight: 'bold' }}>
                  {item.title} →
                </Link>
              </h3>
              <p style={{ margin: '0 0 12px 0', color: '#666', fontSize: '0.85rem', fontStyle: 'italic', lineHeight: '1.4' }}>
                Operational Scope Tags: {item.tags.split(' ').slice(0, 8).join(', ')}...
              </p>
              <div style={{ display: 'flex' }}>
                <Link to={item.path} style={{ fontSize: '0.85rem', color: '#28a745', textDecoration: 'none', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', minHeight: '36px' }}>
                  Browse Page Asset Directory
                </Link>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ padding: 'clamp(20px, 6vw, 40px) 15px', textAlign: 'center', background: '#fafafa', borderRadius: '6px', border: '1px dashed #cbd5e1', boxSizing: 'border-box' }}>
          <p style={{ fontSize: 'clamp(1.05rem, 4.5vw, 1.2rem)', color: '#475569', margin: '0 0 12px 0', fontWeight: '600', lineHeight: '1.4' }}>No exact operational profile tags matched your search entry criteria.</p>
          <p style={{ fontSize: '0.9rem', color: '#64748b', margin: '0', lineHeight: '1.5' }}>Please verify spelling coordinates or search broader terms such as "heart", "visa", "joint", or "cancer".</p>
          <div style={{ marginTop: '24px' }}>
            <Link to="/treatments" className="search-dir-btn" style={{ background: '#0b3c5d', color: '#fff', padding: '12px 24px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(11,60,93,0.15)' }}>
              Browse General Treatments Directory Layout
            </Link>
          </div>
        </div>
      )}

    </div>
  );
}

export default SearchResults;